module.exports = ".personal-info{width:100%;display:block;clear:both;cursor:pointer}.personal-info .title{font-size:14px;color:#9E9E9E}.personal-info .title i{font-size:16px}.personal-info .data{color:#fff}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/shared/ui/personal-info-view/personal-info-view.component.scss
// module id = 721
// module chunks = 0